import { Libraries, useJsApiLoader } from '@react-google-maps/api';

export function useGoogleMapsScript(apiKey: string | undefined, libraries: Libraries) {
  const { isLoaded: scriptLoaded, loadError } = useJsApiLoader({
    id: 'google-map-script',
    googleMapsApiKey: apiKey || 'no-key',
    libraries: libraries
  });

  return { scriptLoaded, loadError };
}
